import { ReactElement } from 'react';
import BaseCrrTimeOfDayPlot from './BaseCrrTimeOfDayPlot';

interface CrrRawTimeOfDayPlotProps {
  session: any;
  equipmentCatalog: any;
  pressureUnit: 'Bar' | 'PSI';
  height?: number;
}

/**
 * Crr Raw vs Time of Day plot showing non-temperature-adjusted Crr values (Crr_xG3)
 * Falls back to Crr_xG5 if Crr_xG3 is not available
 */
export default function CrrRawTimeOfDayPlot({
  session,
  equipmentCatalog,
  pressureUnit,
  height = 400,
}: CrrRawTimeOfDayPlotProps): ReactElement {
  return (
    <BaseCrrTimeOfDayPlot
      session={session}
      equipmentCatalog={equipmentCatalog}
      pressureUnit={pressureUnit}
      height={height}
      title="Crr Raw vs Time of Day"
      yAxisTitle="Crr"
      hoverLabel="Crr Raw Average"
      noDataMessage="No Crr Raw time data available"
      fixedYAxisSpan={0.003}
      traceSuffix="avg_raw"
      dataFieldConfig={{
        traverseSource: 'traverse',
        traverseField: 'Crr_xG3',
        traverseFieldFallback: 'Crr_xG5',
        averageSource: 'average',
        averageField: 'Crr_xG3',
        averageFieldFallback: 'Crr_xG5',
      }}
    />
  );
}
